module.exports = __webpack_public_path__ + "img/logo.910f517e.png";